import React, {useEffect} from "react"
import SideMenuContainer from "components/shared/SideMenuContainer";

import DashboardHome from "./DashboardHome"
import QuarterlyComplianceReport from "./QuarterlyComplianceReport"
import EmailActivity from "./EmailActivity"
import MyActivity from "./MyActivity"
import { useLocation, useNavigate } from "react-router-dom";

const menuItems = [
  { key: 'my-activity', label: 'Activity' },
  { key: 'compliance', label: "Compliance" },
  { key: 'quarterly', label: 'Expiring COIs' },
  { key: 'email-activity', label: 'Email Activity' }
]
export default function({}) {
  const location = useLocation();
  const navigate = useNavigate();
  const activeItem = String(location.hash).replace("#/", "");

  useEffect(() => {
    if (!location.hash) {
      navigate(location.pathname + `#/${menuItems[0].key}`);
    }
  }, [location.pathname])

  return (
    <SideMenuContainer items={menuItems}>
      {activeItem === menuItems[0].key && <MyActivity />}
      {activeItem === menuItems[1].key && <DashboardHome />}
      {activeItem === menuItems[2].key && <QuarterlyComplianceReport />}
      {activeItem === menuItems[3].key && <EmailActivity />}
    </SideMenuContainer>
  )
}
